import { motion } from 'framer-motion';

const PosesionFinalCTA = () => {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById('posesion-efectiva-form');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-24 bg-primary-yellow">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="w-16 h-16 flex items-center justify-center bg-black rounded-2xl mx-auto mb-6">
            <i className="ri-calendar-check-line text-primary-yellow text-3xl"></i>
          </div>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-black mb-4">
            ¿Listo para resolver tu herencia?
          </h2>
          <p className="text-gray-800 text-lg mb-3 max-w-xl mx-auto leading-relaxed">
            Cuéntanos tu situación y evaluamos tu caso con respaldo profesional.
          </p>
          <p className="text-gray-700 text-sm mb-10 max-w-md mx-auto font-medium">
            Este es un servicio profesional pagado. Evaluamos cada caso para entregarte una solución clara y completa.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#posesion-efectiva-form"
              onClick={scrollToForm}
              className="bg-black text-white px-10 py-4 rounded-full font-bold text-base hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Evaluar mi caso
            </a>
            <a
              href="https://wa.me/56912345678?text=Hola%2C%20quiero%20consultar%20sobre%20posesión%20efectiva"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-transparent border-2 border-black text-black px-10 py-4 rounded-full font-semibold text-base hover:bg-black hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl text-green-600"></i>
              Revisar mi situación
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PosesionFinalCTA;
